






































import { Vue, Component } from 'vue-property-decorator'
import Delay from 'lodash/delay'
import { Route } from 'vue-router'

interface TransitionVideoType {
    page: string
    video: string
    videoMobile: string
}

@Component({})
export default class PageTransition extends Vue {
  private routeName: string = ''
  private firstLoad: number = 0
  private transitionVideos: Array<TransitionVideoType> = [
    {
      page: 'index_page',
      video: require('~/assets/videos/transition_01.mp4'),
      videoMobile: require('~/assets/videos/vm_01.mp4'),
    },
    {
      page: 'home_page',
      video: require('~/assets/videos/transition_01.mp4'),
      videoMobile: require('~/assets/videos/vm_01.mp4'),
    },
    {
      page: 'about_page',
      video: require('~/assets/videos/transition_02.mp4'),
      videoMobile: require('~/assets/videos/vm_02.mp4'),
    },
    {
      page: 'training_page',
      video: require('~/assets/videos/transition_03.mp4'),
      videoMobile: require('~/assets/videos/vm_03.mp4'),
    },
    {
      page: 'gallery_page',
      video: require('~/assets/videos/transition_04.mp4'),
      videoMobile: require('~/assets/videos/vm_04.mp4'),
    },
    {
      page: 'contact_page',
      video: require('~/assets/videos/transition_05.mp4'),
      videoMobile: require('~/assets/videos/vm_05.mp4'),
    },
  ]

  get isTransition(): boolean {
      return this.$store.getters.isTransition
  }

  setTransition(arg0: boolean) {
      this.$store.dispatch('setTransition', arg0)
  }

  // execute transition
  beforeEnter() {
    if (!this.firstLoad) {
        this.firstLoad += 1
        return
    }
    this.firstLoad += 1
    this.setTransition(true)

    Delay(() => {
      this.setTransition(false)
      const boxContainer: any = this.$refs.boxContainer
      if (boxContainer) {
        boxContainer.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    }, 4500)
  }

  get pageId(): string {
    const route: Route = this.$route
    if (route && route?.name) {
        this.routeName = route.name + '_page'
        return this.routeName
    }
    return ''
  }

  videoPreview(type: string): string | undefined {
    const transitionVideo: TransitionVideoType | undefined = this.transitionVideos.find(
      (item) => item.page === this.routeName
    )
    let response: string | undefined = ''
    switch (type) {
      case 'desktop':
        response = transitionVideo?.video
        break
      case 'mobile':
        response = transitionVideo?.videoMobile
        break
      default:
        break
    }
    return response
  }
}
